module.exports = __webpack_public_path__ + "static/media/school_11.64b4adb4.jpg";